import React from 'react'

function Icon({ height = '32', width = '32', color = '#ED6521' }: React.SVGProps<SVGSVGElement>) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill="none" viewBox="0 0 32 32">
            <g>
                <mask
                    id="mask0_5569_132133"
                    style={{ maskType: 'alpha' }}
                    width="32"
                    height="32"
                    x="0"
                    y="0"
                    maskUnits="userSpaceOnUse"
                >
                    <path fill="#ED6521" d="M0 0H32V32H0z"></path>
                </mask>
                <g mask="url(#mask0_5569_132133)">
                    <path
                        fill={color}
                        d="M21.97 17.467a.874.874 0 01-.3-.684c0-.277.1-.516.3-.716L25.035 13h-9.034a.968.968 0 01-1-1c0-.288.095-.528.284-.717a.97.97 0 01.716-.283h9.034l-3.067-3.066c-.2-.2-.3-.44-.3-.718 0-.277.1-.516.3-.716.2-.2.433-.3.7-.3.267 0 .5.1.7.3l4.667 4.667c.11.111.194.239.25.383a1.257 1.257 0 010 .9c-.056.145-.14.273-.25.384L23.369 17.5a.9.9 0 01-.7.283 1.02 1.02 0 01-.7-.316zM8.635 25.5l-4.667-4.666a1.081 1.081 0 01-.25-.384 1.23 1.23 0 010-.9c.056-.144.139-.272.25-.383L8.636 14.5c.2-.2.433-.3.7-.3.266 0 .5.1.7.3.2.2.3.44.3.716 0 .279-.1.518-.3.718L6.969 19h9.033c.29 0 .528.095.718.283.188.19.282.429.282.717a.97.97 0 01-1 1H6.97l3.067 3.067c.2.2.3.439.3.716 0 .278-.1.506-.3.684-.2.2-.434.305-.7.316a.9.9 0 01-.7-.283z"
                    ></path>
                </g>
            </g>
        </svg>
    )
}

export default Icon
